import "./index.scss"
export default function UserProtocol() { 
    return(
        <div className="main" id="userprotocol">
            <p className="title">用户协议</p>
            <div className="date-contrainer">
            
            更新日期：2024年07月03日
                <br/>
            生效日期：2024年07月03日
            </div>

<span className="first-indent"/>欢迎您登录“再查查”小程序并使用再查查的各项服务！
<br/>
<span className="first-indent"/>为了使您获得愉悦和安全的服务体验，在此列明本协议条款，详述了用户登录及使用再查查服务所须遵守的条款和条件，请您在登录再查查账户或使用再查查有关服务之前仔细阅读。<span>尤其是以黑体加粗或加下划线显著标示的规则条款，该等规则条款可能涉及相关方的责任免除或限制、法律适用与争议解决，建议您重点阅读。</span>
<br/>
<span className="first-indent"/>本协议的签约双方为再查查的运营商上海百昌科技集团有限公司（以下简称“再查查”或“我们”）与再查查服务的使用人（在本协议中称呼为“您”或者“用户”），本协议是您与我们之间关于您登录再查查账户及使用再查查服务所订立的条款，具有正式书面合同的效力。
<p><span className="first-indent"/>本协议内容包括本协议正文及所有再查查已经发布或将发布的具体服务条款、补充协议、各类规则条款等。所有具体服务条款、补充协议、规则为本协议不可分割的一部分，与协议正文具有同等法律效力。</p>
<p>一、服务条款的确认及接受</p>
1.1【再查查】涉诉大数据风控SaaS系统（以下简称“再查查”）是一款通过算法模型深度融合司法、工商、税务、电力、舆情等数据，为国有企业/金融机构的贷后管理、投后管理、不良资产处置等场景，提供全面、实时、合规的大数据服务的一站式平台（包括但不限于再查查移动应用程序（APP）、再查查PC端网站、再查查小程序以及随技术发展出现的新形态等形式）。再查查各项电子服务的所有权和运作权归“上海百昌科技集团有限公司”所有。
<br/>
1.2再查查将按照本协议条款及有关操作规则为您提供服务。您在使用再查查提供的各项服务之前，应当仔细阅读本协议。您必须同意本协议全部条款，才能登录再查查的账户或使用再查查的全部服务。<span>如您不同意本协议的任意内容，您应立即停止登录或使用。您完成登录程序即表示您已完全知悉并接受本协议，并自愿接受本协议的所有内容的约束。</span>
<br/>
<p>1.3您同意并认可，根据国家法律法规变化及再查查运营需要，再查查有权对本协议条款及相关规则不时地进行修订，相关协议、条款或规则修订后的内容一旦以任何形式公布在再查查上即生效，并取代此前相关内容，我们将尽可能以公告/通知、弹框、站内信或者更新本协议等方式向您告知，您应不时关注再查查公告、提示信息及协议、规则等相关内容的变动。您知悉并确认，如您不同意更新后的内容，应立即停止使用再查查的服务，但您在修订前已经购买的再查查产品/服务将按原协议/条款/规则继续履行；如果您在协议/条款/规则修订后继续登录或使用再查查平台/服务，视为您已充分阅读和理解修订的全部内容，并愿意遵守修订后的协议、条款或规则。</p>
<p>二、服务须知</p>
2.1再查查通过互联网络为用户提供财产线索查询服务及相关服务。使用再查查，您必须：
<br/>
（1）自行配备上网的所需设备，包括个人手机、平板电脑、路由器等；<br/>
（2）自行负担个人上网所支付的与此服务有关的电话费用、网络费用等；<br/>
2.2基于再查查所提供的网络服务的重要性，您确认并同意：<br/>
（1）提供的债权及授权资料真实、准确、完整、合法有效，相关资料如有变动的，应及时更新；<br/>
（2）如果您提供的授权资料不合法、不真实、不准确、不详尽的，您需承担因此引起的相应责任及后果，并且我们保留暂停或终止您使用再查查各项服务的权利。<br/>
<p>三、账户使用与管理</p>
3.1您知悉并承诺，您具有完全民事权利能力，或具备与使用再查查服务相适应的年龄、智力要求，您一旦登录并使用再查查产品/服务，即视为您授权再查查为您获取、汇编、提供相关企业数据。<br/>
3.2您有权使用再查查账户登录或使用再查查产品/服务，您的再查查账户仅限于您本人/本企业使用。未经再查查同意，您无权授权第三方使用您的再查查账户或通过您的再查查账户登录或使用再查查产品/服务。您同意，如存在上述情况，您应对您账号下的一切行为承担责任，且再查查有权采取冻结或关闭账户、删除后台查询记录、拒绝提供服务等措施。
<br/>
3.3使用您的用户名及密码登录再查查后实施的一切行为（包括但不限于在线签署任何协议，输入、提交任何内容），均将被认定属于您本人/本机构进行的行为，您应自行承担该等行为产生的相应义务及责任。
<br/>
3.4您应该妥善、正确的保管、使用、维护您的账户密码，对您的账户密码采取必要和有效的保密措施，<span>如因您自身原因而造成的账户被盗、个人信息泄露等损失，我们将不承担相关责任，但会尽力协助您处理以减少因此给您造成的影响。</span>
<br/>
3.5再查查将对您所提交的登录信息予以保护，对于您所提交的登录信息中涉及个人信息的内容，我们将严格按照本协议及《隐私政策》的规定进行收集、处理、使用和共享安排。
<p>四、用户个人信息保护及授权</p>
4.1您知悉并同意，为方便您使用再查查相关服务，我们将存储您在使用时向再查查提供的的必要信息，包括但不限于您的真实姓名、地址、联系方式、通讯录、相册、日历、定位信息等，以及您向再查查提供的债权信息、金融信息等其他信息。除法律法规规定的情形、为实现服务之所需以及其他用户协议及相关文件约定的情形外，未经您的许可再查查不会向第三方公开、透露您的个人信息（如有）。再查查对相关信息采取专业加密存储与传输方式，利用合理措施保障用户个人信息的安全。
<br/>
4.2您须保证提供给再查查的所有信息，包括但不限于债权信息等，均真实合法有效。您的通讯联系方式应确保畅通，在更改通讯联系方式后应及时在再查查个人资料处更改，因用户原因造成信息无法传达的责任自负。我们发送信息给用户后即视为用户已阅读信息，用户应在收到信息后尽快阅读，如有疑问可联系我们工作人员。
<br/>
4.3您充分理解并同意：
<br/>
（1）为配合行政监管机关、司法机关执行工作，在法律规定范围内再查查有权向上述行政、司法机关提供您在使用再查查时所储存的相关信息，包括但不限于您的登录信息等，或使用相关信息进行证据保全，包括但不限于公证、见证等；
<br/>
（2）再查查依法保障您在安装或使用过程中的知情权和选择权，在您使用再查查服务过程中，涉及您设备自带功能的服务会提前征得您同意，您一经确认，再查查有权开启包括但不限于收集地理位置、读取通讯录、使用摄像头、启用录音等提供服务必要的辅助功能。
<br/>
（3）我们有权根据实际情况，在法律规定范围内自行决定单个用户在再查查及服务中数据的最长储存期限以及用户日志的储存期限，并在服务器上为其分配数据最大存储空间等。
<br/>
4.4企业用户登录使用再查查的，双方就机构的商业秘密信息之保护及授权的权利义务参照本协议4.1至4.3条对用户个人信息之保护及授权的约定执行，但再查查将对用户向再查查提供的信息默认为非商业秘密信息，用户如认为传输至再查查的某信息涉及商业秘密的，应于传输之前提前至少五日以书面形式通知我们以便双方磋商关于保密措施的事项。我们对机构的非商业秘密信息（包括但不限于登录信息等）不承担保密义务，机构如认为传输至再查查的某信息涉及商业秘密的，应于传输之前通知我们。
<br/>
<p>五、用户行为规范</p>
<p><span className="first-indent"/>本协议依据国家相关法律法规规章制定，您同意严格遵守以下义务：</p>
5.1在您提供第三方信息前，均已取得该第三方的合法有效授权。该授权需要在该第三方充分知情的前提下自愿、明确做出。就任何涉及个人信息的获取授权过程中，您应以显著方式、清晰易懂的语言真实准确、完整地向个人告知下列事项：
<br/>
（1）本产品及上海百昌科技集团有限公司的名称和联系方式；<br/>
（2）个人信息的处理目的、处理方，处理的个人信息种类、保存期限；<br/>
（3）个人行使《个人信息保护法》规定权利的方式和程序；<br/>
（4）法律、行政法规规定应当告知的其他事项。<br/>
5.2您仅应以合法查询您获得授权的债务人、担保人等信息为目的使用再查查服务，就您通过再查查服务得知的任何个人/企业信息，仅应在实现上述目的之必要限度内予以使用，严禁用于非法用途或向不特定多数人群泄露。您应保证对经由您许可获知或使用该等信息的任何对象一并遵守本条款义务。
<br/>
5.3在任何情况下，对于您使用再查查服务中涉及由第三方提供相关服务的责任由该第三方承担，我们不承担该等责任。因您自身原因导致再查查服务无法提供或提供时发生任何错误而产生的任何损失或责任，由您自行负责，我们不承担责任。
<br/>
5.4从中国大陆向境外传输资料信息时必须符合中国有关法规；
<br/>
5.5用户若同意本协议或实际使用再查查服务的，则默认您承诺不做以下行为：
<br/>
  5.5.1上传、展示、张贴、传播或以其它方式传送含有下列内容之一的信息（包括但不限于图片、文字、视频、链接、音乐等）：<br/>
（1）反对宪法所确定的基本原则的；<br/>
（2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br/>
（3）损害国家荣誉和利益的；<br/>
（4）煽动民族仇恨、民族歧视、破坏民族团结的；<br/>
（5）破坏国家宗教政策，宣扬邪教和封建迷信的；<br/>
（6）散布谣言，扰乱社会秩序，破坏社会稳定的；<br/>
（7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br/>
（8）侮辱或者诽谤他人，侵害他人合法权利的；<br/>
（9）含有虚假、欺诈、有害、胁迫、侵害他人隐私、骚扰、侵害、中伤、粗俗、猥亵、与公序良俗不符或其它道德上令人反感的内容；<br/>
（10）含有中国法律、法规、规章、条例以及任何具有法律效力之规范所限制或禁止的其它内容的。<br/>
5.5.2利用再查查从事洗钱、窃取商业秘密、窃取个人信息等违法犯罪活动；<br/>
5.5.3干扰再查查的正常运转，侵入再查查或国家计算机信息系统；<br/>
5.5.4为任何非法目的而使用网络服务系统；<br/>
5.5.5恶意使用再查查账号；<br/>
5.5.6教唆他人从事本条所禁止的行为；<br/>
5.5.7利用再查查服务从事以下活动：<br/>
（1）未经书面允许，进入计算机信息网络或者使用计算机信息网络资源的；<br/>
（2）未经书面允许，对计算机信息网络功能进行删除、修改或者增加的；<br/>
（3）未经书面允许，进入计算机信息网络中对存储、处理或者传输的数据和应用程序进行删除、修改或者增加的；<br/>
（4）故意制作、传播计算机病毒（包括木马）等破坏性程序，盗取其他用户账户、密码、隐私、操控他人电脑的；<br/>
（5）其他危害计算机信息网络安全的行为。<br/>
5.5.8未经书面允许，利用再查查从事广告发布、变相广告、口碑营销、产品销售、传销等行为。<br/>
5.5.9除发布者外，删除或修改其他个人或公司公布的资料。<br/>
5.5.10未经我们同意，擅自给公布信息的个人或公司发电子邮件、打电话、寄信或以其他方式进行擅自接触。<br/>
5.6如用户在使用网络服务时违反上述任何规定，我们有权要求用户改正或直接采取一切必要的措施（包括但不限于删除用户输入或下载的内容、暂停或终止用户使用网络服务的权利）以减轻用户不当行为而造成的影响。
5.7在使用再查查财产线索查询服务过程中，您发现任何可能侵害自己或我们权益的事实时，应及时通知我们并提供相应的证明材料。因投诉不实给我们或第三方造成损失的，应承担法律责任。
<br/>
5.8当第三方认为用户于再查查查询并使用或处理的信息侵犯其权利，并根据《信息网络传播权保护条例》或者相关法律规定向再查查发送权利通知书时，用户同意我们可以要求其删除涉嫌侵权信息，除非用户提交书面证据材料排除侵权的可能性。
<span>
5.9您理解并同意，为了确保您按照法律法规及本协议、具体服务规则规定使用再查查的服务，我们或相关国家监管机构有权随时对您使用再查查服务的情况进行监督和检查。</span>我们将自行或是根据国家机构要求，对您享有的服务开展风险评估、检测、检查和审计，如涉及隐私信息的，我们会采取合理的保护措施，您应当予以配合。如您拒绝的，再查查有权停止向您提供服务，直至您配合并且我们确认您使用服务行为符合法律及本协议规定。

<p>六、再查查使用规范</p>
6.1关于再查查的路径：<br/>
（1）您可以登录【再查查】小程序或PC网页端使用；<br/>
（2）为了改善用户体验、完善服务版本内容，再查查将不断努力开发新的服务，并为您不时提供再查查版本更新，再查查新版本发布后，旧版本的软件可能无法使用，再查查不保证旧版再查查继续可用及相应的客户服务，请您随时核对并访问最新版本。
<br/>
6.2除非法律允许或我们书面许可，您使用再查查过程中不得从事下列行为：<br/>
（1）删除再查查及其副本上关于著作权的信息；<br/>
（2）对再查查进行反向工程、反向汇编、反向编译，或者以其他方式尝试发现再查查的源代码；<br/>
（3）对上海百昌科技集团有限公司拥有知识产权的内容进行使用、出租、出借、复制、修改、链接、转载、汇编、发表、出版、建立镜像站点等；<br/>
（4）对再查查或者再查查运行过程中释放到任何终端内存中的数据、软件运行过程中客户端与服务器端的交互数据，以及再查查运行所必需的系统数据，进行复制、修改、增加、删除、运行或创作任何衍生作品，形式包括但不限于使用插件、外挂或非经上海百昌科技集团有限公司授权的第三方工具/服务接入再查查和相关系统；
<br/>
（5）通过修改或伪造软件运行中的指令、数据，增加、删减、变动软件的功能或运行效果，或者将用于上述用途的软件、方法进行运营或向公众传播，无论这些行为是否为商业目的；
<br/>
（6）通过非上海百昌科技集团有限公司开发、授权的第三方软件、插件、外挂、系统，登录或使用上海百昌科技集团有限公司软件及服务，或制作、发布、传播上述工具；
<br/>
（7）自行或者授权他人、第三方软件对再查查及其组件、模块、数据进行干扰。
<br/>
6.3再查查有权对您向再查查提供的一切信息进行收集、存储、使用、加工、传输、提供、公开、删除等处理，并要求您在向再查查提供该等信息之前，已取得该等信息所涉机构和个人关于由本再查查对该等信息实施上述处理的充分许可。再查查有权随时要求您提供上述许可的有效原件。
<br/>
6.4再查查有权对您向再查查提供的一切信息进行合规审查，如再查查经审查认为该等信息反映的您诉求（无论为财产线索查找、债权清收委托管理）缺乏授权/合法性/真实性/有效性,则再查查有权拒绝您该等诉求，而无需为此承担任何责任。
<br/>
6.5再查查有权按本协议约定收取本协议项下应收款项。
<br/>
6.6再查查有权要求用户尊重并维护再查查的知识产权，您应予以充分配合。
<p>七、责任承担</p>
7.1如果我们发现或收到他人举报投诉您违反本协议约定或违法违规的，我们有权要求您删除相关内容，并视行为情节对违规帐号处以包括但不限于警告、限制或禁止使用部分或全部功能、账户封禁直至注销的处罚，并公告处理结果。
<br/>
7.2我们有权依据合理判断对违反有关法律法规或本协议规定的行为采取适当的法律行动，并依据法律法规保存有关信息向有关部门报告等，您应独自承担由此而产生的一切法律责任。
<br/>
7.3您理解并同意，因您违反本协议或或经在此提及而纳入本协议的其他文件，或您违反了法律、法规、规章、政府规范性文件或侵害了第三方的权利，导致或产生第三方主张的任何索赔、要求或损失，您应当独立承担责任；我们因此遭受损失的，您也应当一并赔偿。
<br/>
7.4由于您违反本协议或任何法律、法规或侵害第三方的权利，而引起第三方对我们提出的任何形式的索赔、要求、诉讼，我们有权向您追偿相关损失，包括但不限于我们的法律费用、名誉损失、及向第三方支付的补偿金等。
<br/>
7.5在任何情况下，对于您使用我们服务中涉及由第三方提供相关服务的责任由该第三方承担，我们不承担该等责任。因您自身原因导致再查查服务无法提供或提供时发生任何错误而产生的任何损失或责任，由您自行负责，我们不承担责任。
<br/>
7.6除非另有明确的书面说明,上海百昌科技集团有限公司不对再查查的运营及其包含在再查查上的信息、内容、材料、产品（包括软件）或服务作任何形式的、明示或默示的声明或担保（根据中华人民共和国法律另有规定的以外）。
<p>八、知识产权</p>
8.1您一旦接受本协议，即表明您主动将您在任何时间段在再查查发表的任何形式的信息内容和图片授权给上海百昌科技集团有限公司使用，包括但不限于在百昌拍卖网站、官方微博、微信、知乎、Facebook、Instagram及其他社交平台、新闻平台及旗下其他产品中使用和传播这些内容/图片。
<br/>
8.2本协议已经构成《中华人民共和国著作权法》第二十七条（条文序号依照2020年11月11日修订版《著作权法》确定）及相关法律规定的著作财产权等权利转让书面协议，其效力及于您在再查查上发布的任何受著作权法保护的作品内容，无论该等内容形成于本协议订立前还是本协议订立后。
<br/>
8.3用户在再查查输入或提交的内容，用户应保证其为著作权人或已取得相关权利人的合法授权，并且该内容不会侵犯任何第三方的合法权益，并保证该等内容具有准确性、真实性、正当性、合法性，且不得以任何形式侵犯第三人权益，因抄袭、转载、侵权等行为所产生的纠纷由用户自行解决，上海百昌科技集团有限公司不承担任何法律责任。
<br/>
8.4除法律另有强制性规定外，未经上海百昌科技集团有限公司明确的特别书面许可,任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用再查查的信息内容，否则，上海百昌科技集团有限公司有权追究其法律责任。
<br/>
8.5再查查所发出或刊登的资料信息（诸如文字、图表、标识、按钮图标、图像、声音文件片段、数字下载、数据编辑和软件），均是上海百昌科技集团有限公司或其内容提供者的财产，受中国和国际版权法的保护。再查查上所有内容的汇编是上海百昌科技集团有限公司的排他财产，受中国和国际版权法的保护。再查查上所有软件都是上海百昌科技集团有限公司或其关联公司或其软件供应商的财产，受中国和国际版权法的保护。
<p>九、免责声明</p>
9.1您理解并同意，在符合法律规定的情况下，我们对以下事由所导致的服务中断、服务不及时、服务安全性、服务终止或给您造成的其他损失不承担责任，但我们将努力在第一时间与相关部门配合，及时进行修复以减少因此给您造成的损失和影响：
<br/>
（1）不可抗力因素。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于信息网络设备维护、信息网络连接故障、电脑、通讯或其他系统的故障、电力故障、罢工、劳动争议、暴乱、起义、骚乱、生产力或生产资料不足、火灾、洪水、风暴、爆炸、战争、政府行为、法律法规变动、司法行政机关的命令等造成的不能服务或延迟服务情况。
<br/>
（2）受到他人蓄意破坏、计算机病毒、木马或其他恶意程序、黑客攻击的破坏。
<br/>
（3）设备兼容性错误、网络过载、第三方网站原因等问题。
<br/>
（4）用户操作不当。<br/>
（5）用户通过非平台授权的方式使用本服务。<br/>
（6）其他我们无法控制或合理预见的情形。<br/>
9.2在使用再查查服务的过程中，您可能会遇到网络信息或其他用户行为带来的风险。我们将对相关内容开展日常检查并在收到举报或投诉时进行相应处理，但我们不对非再查查所发出或刊登的任何信息的真实性、适用性、合法性承担责任，也不对因第三方侵权行为给您造成的损害负责。
<br/>
9.3由于您自己将账户密码告知他人、与他人共享账户、转借或出让账户给他人使用，由此导致任何个人信息的泄露、财产损失等风险由您自行承担，我们无需承担任何责任。
<br/>
9.4由于您向再查查提供错误、不完整、不实信息等造成不能正常使用再查查服务或遭受任何其他损失，我们无需承担任何责任。
<br/>
9.5由于短信运营商网络运转不正常，天灾人祸、战争等原因造成网络瘫痪或者接收短信的您手机网络通道不畅通等不可抗力因素，而导致我们无法向您发出信息或发出的信息无法即时、准确地送达您，我们无需承担相应责任。
<br/>
9.6再查查可能会提供其他网站的链接，但这些链接的网站并非由再查查控制，这些网站的使用及具体内容也不代表我们立场，我们无需对您因浏览或使用链接网站而承担相关责任。
<br/>
9.7我们不保证客户端在操作上不会中断或没有错误，不保证本产品会纠正客户端的所有缺陷，亦不保证本产品能满足您的所有要求。如果您对本产品的任何部分或本协议条款的任何部分不满意，您唯一的和全部的解决方案就是停止继续使用本产品。
<br/>
9.8您知悉并同意，再查查仅为技术服务产品，尽力向您提供稳定的技术服务，您同意严格按照本协议约定及再查查规则使用技术服务。如您行为违反本协议及再查查规则，再查查有权停止向您提供服务，由此产生的损失及不利后果由您自行承担。
<br/>
9.9本协议项下的产品和服务将按“现状”和按“可得到”的状态提供，再查查将在现有技术的基础上尽最大努力提供相应的安全措施以保障服务安全和正常运行。但由于可能存在的计算机病毒、网络通讯故障、浏览器兼容问题、系统维护等方面的因素以及可能发生的不可抗力事件，我们在此明确声明对技术服务不作任何明示或暗示的保证，包括但不限于：对服务的可适用性、没有错误或疏漏、持续性、准确性、可靠性、适用于某一特定用途。对此您予以理解并不应要求我们承担责任。
<br/>
9.10<span>再查查仅向您提供技术服务以便您获取查询企业的综合经营信息或财产线索，再查查不对查询结果及所涉信息的真实性、合法性做任何明示或暗示的担保，或对此承担任何责任。对于因您使用再查查财产线索查询服务或增值服务引起的相关纠纷，由您自行解决，我们不承担任何相关责任。
</span>
<br/>
9.11再查查不对所承载的内容（文、图）的真实性、科学性、严肃性做任何形式保证。
<br/>
9.12您理解并同意，在法律允许的范围内，我们不就您遭受的任何利润损失（无论直接或间接产生）、商誉损失、机会损失、数据丢失、其他间接或附带损失以及因您自身过错或原因导致的损失承担赔偿责任。任何我们需承担的损失赔偿责任的金额以过去12个月您或您相应的企业用户向我们支付的金额为限。
<br/>
9.13我们不对您因第三方的行为或不作为造成的损失承担任何责任，包括但不限于支付服务、网络接入服务、任意第三方的侵权行为。
<br/>
<p>十、法律管辖适用及其他</p>
10.1本协议的生效、履行、解释及争议的解决均适用中华人民共和国（港、澳、台地区除外）的法律。本协议或某项产品/服务的单独协议或特别条款因与国家法律法规相抵触而导致部分无效的，不影响其他部分的效力。您同意，解决争议时，应以您同意的最新版本的《用户协议》为准。
<br/>
10.2如双方就本协议内容或其执行发生任何争议，双方应尽力友好协商解决；协商不成时，任何一方均可向协议签订地人民法院提起诉讼。本协议签订地为中华人民共和国上海市闵行区。因争议解决而发生的费用（包括但不限于诉讼、保全/担保、公证/评估/鉴定、律师费用等）将由违约方承担。
<br/>
10.3对于因本协议争议而引致的任何纠纷，您同意裁判机关按照您向再查查提供的信息（包括但不限于联系人、邮箱、手机号码、微信、QQ、联系地址等内容）进行法律文书（包括但不限于权利申请类型文件【例如起诉状、反诉状、仲裁申请书、保全申请书等】的正副本、证据、裁判机关及相关评估、鉴定机构出具的文书等）送达，裁判机关可以采取以上一种或多种方式送达，送达时间以最先送达的为准。您确认，上述送达方式适用于整个争议解决阶段；若您所提供的送达信息不确切或不及时告知变更的，使法律文书无法送达或未及时送达，由此产生的不利后果将由您自行承担。
<br/>
10.4本协议自您同意勾选并登录成为再查查正式用户之日起生效，除非我们终止本用户协议或者用户丧失再查查用户资格，否则本协议始终有效。本协议终止并不免除用户根据本协议或其他有关协议、规则所应承担的义务和责任。
<br/>
10.5如果本协议中任何一条被视为废止、无效或因任何理由不可执行，该条应视为可分的且并不影响任何其余条款的有效性和可执行性。
<br/>
10.6本协议未明示授权的其他权利仍由上海百昌科技集团有限公司保留，您在行使这些权利时须另外取得上海百昌科技集团有限公司的书面许可。上海百昌科技集团有限公司如果未行使前述任何权利，并不构成对该权利的放弃。
<br/>
10.7上海百昌科技集团有限公司对本用户协议享有最终的解释权。
<br/>
10.8您确认您已仔细阅读以上条款，同时完全接受以上条款的内容。
<p>十一、如何联系我们</p>
11.1如对本协议内容有任何疑问、意见或建议，您可以通过以下方式与我们联系，我们将在收到您的需求后，在15个工作日内予以回复：
<br/><br/>
再查查客服电话：400-015-0005
        </div>
    )
}